var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-post"},[_c('div',{staticClass:"share-post-button",attrs:{"data-cy":"share-post-button"},on:{"click":_vm.shareByEmail}},[_c('a',{staticClass:"edit-post-text"},[_vm._v(" "+_vm._s(_vm.$t('post.postShare.share'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }